module.exports = __webpack_public_path__ + "static/img/8.e0ab5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/8.png
// module id = 3cRS
// module chunks = 1